import { useEffect, useRef } from 'react';

// Only fire on dependency changes, not initial render
const useDidMountEffect = (func: any, dependencies: any[]) => {
    const didMount = useRef(false);

    useEffect(() => {
        if (didMount.current) {
            func();
        } else {
            didMount.current = true;
        }
    // React Hook useEffect was passed a dependency list that is not an array literal. 
    // This means we can't statically verify whether you've passed the correct dependencies
    // Skipping check on this line as eslint is unable to parse this
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencies);
};

export default useDidMountEffect;
